export default "__VITE_ASSET__nOyDDOtj__"